/*
 * @Author: chenqing
 * @Date: 2023-11-03 16:43:15
 * @LastEditors: chenqing
 * @LastEditTime: 2023-11-03 16:58:08
 * @FilePath: /chaojimaHome/App/assets/scripts/modules/industryApplication/tdkDict.js
 * @Description:
 */
const dict = [
  {
    title: '经典案例丨浙农码_数字社会乡村服务场景_超级码科技股份',
    keywords: '浙农码，数字乡村服务，数字三农案例，全农码 ',
    description:
      '浙农码是由浙江省农业农村厅牵头，超级码科技股份主导建设的数字社会乡村服务重要场景应用，也是浙江省数字化改革的重要成果之一。浙农码的应用备受好评，目前完成赋码1900万+，用码量2.4亿余次。',
  },
  {
    title: '经典案例丨浙江省茶产业大脑_全链路数字化管理应用_超级码科技股份',
    keywords: '茶叶防伪溯源，茶产业大脑解决方案，茶叶防窜货，茶叶质量追溯',
    description:
      '超级码科技股份茶产业大脑，全链路溯源管理服务，打通茶叶从种植到销售服务全环节的信息记录，真正做到防伪溯源防窜货，打击假冒伪劣，维护企业利益品牌形象，让消费者喝到正宗好茶。',
  },
  {
    title: '经典案例丨安吉白茶产业大脑_数字化茶园典范_超级码科技股份',
    keywords: '安吉白茶，茶产业大脑，茶叶防窜货，茶叶防伪溯源',
    description:
      '超级码科技股份打造安吉白茶产业大脑，全链路溯源管理服务，打通茶叶从种植到销售服务全环节的信息记录，真正做到防伪溯源防窜货，打击假冒伪劣，实现安吉白茶全产业链数字化生产水平、监管水平、服务水平、品牌价值的提升。',
  },
  {
    title: '经典案例丨东阳生猪产业大脑_数字化畜牧养殖_超级码科技股份 ',
    keywords: '东阳生猪，质量安全追溯体系，畜牧业数字化生产',
    description:
      '浙江省金华市政府联合超级码科技股份建设，覆盖生猪全产业各环节的系统应用，实现生猪养殖环境实时监测、化肥兽药精准管控、生产加工全程监管、生产态势精准感知等，并建立了完整可信的质量安全追溯体系，打造生猪产业数字化的典型范例。',
  },
  {
    title: '经典案例丨玉环海捕_海捕水产品溯源_超级码科技股份 ',
    keywords: '玉环海捕，海捕水产品溯源，海捕水产品防伪',
    description:
      '超级码科技股份为玉环海捕打造一套专属防伪溯源解决方案。从源头捕捞、生产加工、仓储管理、流通管理到销售管理的全链路全流程信息记录，做到来源可查、去向可追、责任可究！',
  },
  {
    title: '经典案例丨湖西稻虾_全产业链数字化_全流程追溯_超级码科技股份',
    keywords: '湖西稻虾，全流程追溯，农业数字化，智慧农旅',
    description:
      '超级码科技股份为湖西稻虾产业构建了全产业链智慧监管系统、智慧化农旅服务体系，将数字化设施引入到实际的生产种植养殖中，实现稻虾养殖过程中全流程溯源以及稻虾产业与旅游业相结合的智慧化服务。',
  },
  {
    title: '经典案例丨一亩山万元钱_林业科技富民新模式_超级码科技股份',
    keywords: '一亩山万元钱，林农增收致富，乡村振兴',
    description:
      '超级码科技股份通过大数据、云计算、人工智能等现代信息技术，以流程再造实现跨部分、跨地域、跨层级高效协同，为群红提供个性化服务，构建人机协同的数字化、网络化、智能化集成应用系统。',
  },
  {
    title: '经典案例丨婺城区乡村大脑_助力乡村振兴_数字三农_超级码科技股份 ',
    keywords: '乡村大脑，数字乡村，数字三农，乡村振兴',
    description:
      '婺城数字乡村大脑是由超级码科技股份为婺城区县域构建服务“三农”的农业农村数据平台，全面支撑数字乡村业务和应用，解决数字乡村相关数据的汇聚、治理和应用问题。',
  },
  {
    title: '经典案例丨指南村乡村大脑_助力乡村振兴_数字三农_超级码科技股份',
    keywords: '乡村大脑，数字乡村，数字三农，乡村振兴',
    description:
      '指南村乡村大脑是由超级码科技股份为指南村构建服务“三农”的农业农村数据平台，全面支撑数字乡村业务和应用，解决数字乡村相关数据的汇聚、治理和应用问题。',
  },
  {
    title: '经典案例丨郝家冲村未来乡村_乡村数字化应用场景_超级码科技股份 ',
    keywords: '未来乡村，数字乡村，乡村智慧治理，乡村智慧农旅',
    description:
      '郝家冲村未来乡村是由超级码科技股份围绕郝家冲村治理热点、难点、堵点问题，打造的集移动智慧云党建、智慧村务、村级安防、云视讯会议、智慧化云喇叭等贴近群众现实需要的数字化应用场景。',
  },
  {
    title: '经典案例丨杨家村未来乡村_乡村数字化应用场景_超级码科技股份',
    keywords: '未来乡村，数字乡村，乡村智慧治理，乡村智慧农旅',
    description:
      '超级码科技股份通过数字化手段，为万市镇杨家村银杏古树保护工作赋能，提升治理水平，并推进银杏谷产业的发展，提升区域品牌，实现了产业兴旺，三产融合新业态，村企共富创增收的繁荣景象。',
  },
];

module.exports = dict;
